<template>
  <div class="header">
    <div class="header__wrap main-container">
      <span>
        <h2>{{ getTranslatedText("live number draws") }}</h2>
        <span>{{ getTranslatedText("today draws") }}</span>
      </span>
      <div class="header__right">
        <h2>&nbsp;</h2>
        <BalanceDisplay />
      </div>
    </div>
  </div>
</template>

<script>
import languageMixins from "@/mixins/language-mixins";
import BalanceDisplay from "@/components/common/BalanceDisplay.vue";

export default {
  mixins: [languageMixins],
  components: {
    BalanceDisplay,
  },
};
</script>

<style lang="scss">
@import "@/public/scss/header/_index.scss";
.header__wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header__right {
  align-items: center;
  color: #fff;
  font-size: 14px;
}
</style>
